import dayjs, {OpUnitType} from "dayjs"
import moment from "moment"
import "moment-timezone"

const SUNDAY = 0
const SATURDAY = 6
const WEEKEND = [SATURDAY, SUNDAY]

dayjs.locale("ko")

const toYYYYMMDD = (isoTime: any) => {
  return dayjs(isoTime).format("YYYY-MM-DD")
}

const toHHmmss = (isoTime: any) => {
  return dayjs(isoTime).format("HH:mm:ss")
}

const toYYYYMMDDHHmmss = (isoTime: any) => {
  return dayjs(isoTime).format("YYYY-MM-DD HH:mm:ss")

}

const toHHmm = (isoTime: any) => {
  return dayjs(isoTime).format("HH:mm")
}

const toTimestamp = (isoTime: any) => {
  return isoTime ? Date.parse(toKST(isoTime)) : 0
}

const toKST = (isoTime: string) => {
  return isoTime ? moment.tz(isoTime, "Asia/Seoul").format() : ""
}

const isWeekend = (isoTime: any) => {
  return WEEKEND.includes(new Date(isoTime).getDay())
}

const subtractToYYYYMMDD = (isoTime: any, value: number, unitType: OpUnitType) => {
  return dayjs(isoTime).subtract(value, unitType).format("YYYY-MM-DD")
}

export { toHHmmss, toHHmm, toYYYYMMDD, toTimestamp, isWeekend, subtractToYYYYMMDD }
